"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppsPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var section_swapper_1 = require("../../components/section_swapper");
var app_download_png_1 = __importDefault(require("../../assets/app/app_download.png"));
var AppsPage = function (props) {
    var _a = props;
    (0, react_1.useEffect)(function () {
        //
    }, []);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
            react_1.default.createElement(section_swapper_1.SectionSwapperComponent, { imageSide: "right", image: app_download_png_1.default, smallTitle: "", bigTitle: "Experience the convenience of on-demand shopping like never before with the MyTLC app \u2013 Your Health Companion!", 
                // buttonText="Learn More"
                description: "Welcome to the Local Choice, where shopping is a breeze. With our app, you can shop effortlessly across all of our branches, no matter where you are in the nation. Say goodbye to long queues and hello to instant access to a world of products and services right at your fingertips.", content: [
                    {
                        title: "Why choose Local Choice?.",
                        list: [
                            "Shop anytime, anywhere, and from any of our nationwide branches.",
                            "Browse a wide selection of products and services.",
                            "Enjoy seamless, hassle-free shopping with our user-friendly app.",
                            "Get access to exclusive deals and promotions.",
                            "Experience the ultimate in convenience and efficiency.",
                        ],
                    },
                    {
                        description: "Download the MyTLC app today and discover a whole new way to shop locally, instantly, and effortlessly. Your health companion is just a tap away!",
                    },
                ] }),
            react_1.default.createElement("div", { className: "flex pt-5 w-full" },
                react_1.default.createElement(doshx_controls_web_1.AppStoreButtonsControl, { orientation: "horizontal", size: "medium", appStore: {
                        onClick: function () {
                            window.open("https://apps.apple.com/us/app/mytlc-health-companion/id6443604249", "_blank");
                        },
                    }, playStore: {
                        onClick: function () {
                            window.open("https://play.google.com/store/apps/details?id=mytlc.mobile", "_blank");
                        },
                    }, appGallery: {
                        onClick: function () {
                            window.open("https://appgallery.huawei.com/#/app/C109174639", "_blank");
                        },
                    } })))));
};
exports.AppsPage = AppsPage;
